export default {
  VEHICLE_CATEGORIES_SUBTILES_TITLE:
    '<div class="cm_vehicle-categories__subcategories_title">Browse other categories</div>',
};
